import { Link } from "react-router-dom"
import "./error.css"
export default function Error(){
    return(
        <div className="error">
            <div className="error-image">
                <img src={require("./home/images/error.png")} alt="error" />
            </div>
            <div className="error-button">
                <Link to="/">
                    Go Back to Home Page
                </Link>
            </div>
        </div>
    )
}